


import React, { useState } from "react";
import { Helmet } from 'react-helmet';
import Footer from "../../components/es/FooterEs";
import { Link } from "react-router-dom";

function StudyInRussia() {

    // Estado para controlar el acordeón
    const [activeIndex, setActiveIndex] = useState(null);

    const toggleAccordion = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };
    
     // Definir una única fuente de verdad para los metadatos
     const postMetadata = {
        title: "¿Por Qué Estudiar en Rusia? 10 Razones Clave y Guía Completa 2025 | PLAN RUSIA",
        description: "¿Vale la pena estudiar en Rusia? Descubre 10 ventajas académicas, económicas y culturales respaldadas por datos oficiales. Guía actualizada con requisitos para 2025",
        ogTitle: "¿Por Qué Estudiar en Rusia? Ventajas Clave para Estudiantes Internacionales",
        ogDescription: "Todo lo que necesitas saber para estudiar en Rusia: desde admisión hasta vida estudiantil. ¡Descubre oportunidades únicas!",
        imageUrl: "https://planrusia.com/assets/img/gallery/rusas-universidad-clases.png",
        url: "https://planrusia.com/prueba",
        keywords: "estudiar en Rusia, universidades rusas, becas en Rusia, estudiar medicina en Rusia, costo de vida Rusia"
    };

    return (
        <main>
            {/* ========================== SEO ========================== */}
            <Helmet>
                {/* Title y meta description básicos */}
                <title>{postMetadata.title}</title>
                <meta name="description" content={postMetadata.description} />
                
                {/* Open Graph para Facebook, WhatsApp, etc. */}
                <meta property="og:title" content={postMetadata.ogTitle} />
                <meta property="og:description" content={postMetadata.ogDescription} />
                <meta property="og:image" content={postMetadata.imageUrl} />
                <meta property="og:url" content={postMetadata.url} />
                <meta property="og:type" content="article" />
                
                {/* Twitter Card */}
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content={postMetadata.ogTitle} />
                <meta name="twitter:description" content={postMetadata.ogDescription} />
                <meta name="twitter:image" content={postMetadata.imageUrl} />
                
                {/* Otros metadatos importantes */}
                <meta name="keywords" content={postMetadata.keywords} />
                <link rel="canonical" href={postMetadata.url} />
            </Helmet>

            {/* ==================== Contenido Principal ==================== */}
            <section className="blog_area single-post-area section-padding">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-8 posts-list">
                            <div className="single-post">
                                <div className="feature-img">
                                    <img
                                        className="img-fluid"
                                        src="/assets/img/gallery/rusas-universidad-clases.png"
                                        alt="Estudiantes internacionales en campus universitario ruso"
                                        loading="lazy"
                                    />
                                </div>

                                <div className="blog_details">
                                    <h1 itemProp="headline">
                                        ¿Por Qué Estudiar en Rusia? 10 Ventajas que Debes Conocer en 2025
                                    </h1>

                                    <div className="meta-info" itemScope itemType="http://schema.org/Article">
                                        <span itemProp="datePublished"> 1 Junio 2025</span>
                                        <span itemProp="author"> Por - Consejería Educativa Rusa</span>
                                    </div>

                                    <ul className="blog-info-link mt-3 mb-4">
                                        <li>
                                            <a href="#">
                                                <i className="fa fa-user" /> Educación, Guías
                                            </a>
                                        </li>
                                        <li>
                                            <a href="#">
                                                <i className="fa fa-comments" /> 12 Comentarios
                                            </a>
                                        </li>
                                    </ul>

                                    <article itemProp="articleBody">


                                        <p className="excert">
                                            Con más de 300,000 estudiantes internacionales (según <a href="https://uis.unesco.org/" target="_blank" rel="noopener noreferrer">UNESCO</a>), Rusia se posiciona como potencia educativa. Pero ¿qué la hace tan atractiva? Analizamos factores académicos, económicos y culturales.
                                        </p>


                                        {/* ============ ÍTEM 1 ============ */}
                                        <h2>1. Educación de Clase Mundial. Excelencia Académica a Costo Accesible</h2>

                                        <p>
                                            <strong>Ranking QS 2024</strong> incluye 17 universidades rusas entre las top 500 mundial. Destacan:
                                        </p>
                                        <ul>
                                            <li>• Universidad Estatal de Moscú (Lomonósov) - #74 mundial en Física</li>
                                            <li>• MIPT - Top 50 en Ingeniería Nuclear</li>
                                            <li>• MGIMO - #1 en Relaciones Internacionales en Europa del Este</li>
                                        </ul>
                                        <p>
                                            Matrículas desde $2,500 anuales vs $50,000 en Ivy League (<a href="https://www.minobrnauki.gov.ru/" target="_blank" rel="noopener noreferrer">Ministerio de Educación ruso</a>).
                                        </p>



                                        <p>Rusia ocupa el <strong>6° lugar global</strong> en producción científica (Scimago 2023). Destacan:</p>
                                        <div className="row mb-4">
                                            <div className="col-md-6">
                                                <div className="card uni-card h-100">
                                                    <div className="card-body">
                                                        <h5>Universidad Estatal de Moscú (MSU)</h5>
                                                        <ul>
                                                            <li>#74 en QS World Rankings 2024</li>
                                                            <li>11 Premios Nobel</li>
                                                            <li>Matrícula: $3,000-$6,000/año</li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="card uni-card h-100">
                                                    <div className="card-body">
                                                        <h5>ITMO University</h5>
                                                        <ul>
                                                            <li>#1 en Ciencias de la Computación en Rusia</li>
                                                            <li>7 veces campeón ACM ICPC</li>
                                                            <li>Becas completas disponibles</li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>


                                        {/* ============ ÍTEM 2 ============ */}
                                        <h2>2. Becas Gubernamentales (Cuota Completa) para Extranjeros</h2>

                                        <ol>
                                            <li>15,000 Becas Anuales del Gobierno para los mejores estudiantes extranjeros</li>
                                            <li>Cobertura total: matrícula + alojamiento + seguro médico</li>
                                            <li>Postulación online noviembre - diciembre de cada año</li>
                                        </ol>

                                        <table className="table table-bordered">
                                            <thead className="thead-dark">
                                                <tr>
                                                    <th>Tipo de Beca</th>
                                                    <th>Beneficios</th>
                                                    <th>Requisitos</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>Beca Gubernamental</td>
                                                    <td>100% matrícula + alojamiento</td>
                                                    <td>Promedio mínimo 80/100</td>
                                                </tr>
                                                <tr>
                                                    <td>Open Doors</td>
                                                    <td>Matrícula + $500/mes</td>
                                                    <td>Prueba de talento y conocimiento</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <p><small>Fuente: <a href="https://education-in-russia.com" target="_blank" rel="noopener">Education in Russia</a></small></p>




                                        {/* ============ ÍTEM 3 ============ */}


                                        <h2>3. Programas en Inglés (Sin Dominar Ruso) </h2>

                                        <p>
                                            58 universidades ofrecen 700+ programas en inglés en áreas como:
                                        </p>
                                        <ul>
                                            <li>• Medicina (MBBS reconocido por OMS)</li>
                                            <li>• Ingeniería Aeroespacial</li>
                                            <li>• Inteligencia Artificial</li>
                                            <li>• Ingeniería Nuclear </li>
                                        </ul>

                                        <div className="accordion mb-4" id="programsAccordion">
                                            {[
                                                {
                                                    title: "Medicina (MBBS)",
                                                    content: (
                                                        <ul>
                                                            <li><strong>Duración:</strong> 6 años</li>
                                                            <li><strong>Reconocimiento:</strong> OMS, ECFMG, GMC</li>
                                                            <li><strong>Top Universidades:</strong>
                                                                <ul>
                                                                    <li>Sechenov University (Moscú)</li>
                                                                    <li>RUDN University</li>
                                                                    <li>Kazan Federal University</li>
                                                                </ul>
                                                            </li>
                                                            <li><strong>Requisitos:</strong>
                                                                <ul>
                                                                    <li>Notas mínimas: 80% en Biología/Química</li>
                                                                    <li>Examen NEET para estudiantes indios</li>
                                                                </ul>
                                                            </li>
                                                        </ul>
                                                    )
                                                },
                                                {
                                                    title: "Ingeniería Aeroespacial",
                                                    content: (
                                                        <ul>
                                                            <li><strong>Duración:</strong> 4 años (Bachelor)</li>
                                                            <li><strong>Instituciones destacadas:</strong>
                                                                <ul>
                                                                    <li>Moscow Aviation Institute (MAI)</li>
                                                                    <li>Bauman Moscow State Technical University</li>
                                                                </ul>
                                                            </li>
                                                            <li><strong>Enfoques:</strong>
                                                                <ul>
                                                                    <li>Diseño de cohetes</li>
                                                                    <li>Propulsión espacial</li>
                                                                    <li>Materiales compuestos</li>
                                                                </ul>
                                                            </li>
                                                            <li><strong>Prácticas:</strong> Roscosmos, United Aircraft</li>
                                                            <li><strong>Salario promedio:</strong> $3,500/mes</li>
                                                        </ul>
                                                    )
                                                },
                                                {
                                                    title: "Inteligencia Artificial",
                                                    content: (
                                                        <ul>
                                                            <li><strong>Duración:</strong> 2 años (Master)</li>
                                                            <li><strong>Instituciones destacadas:</strong>
                                                                <ul>

                                                                    <li>Bauman Moscow State Technical University</li>
                                                                </ul>
                                                                <li><strong>Áreas cubiertas:</strong>
                                                                    <ul>
                                                                        <li>Machine Learning</li>
                                                                        <li>Computer Vision</li>
                                                                        <li>Procesamiento de Lenguaje Natural</li>
                                                                    </ul>
                                                                </li>
                                                                <li><strong>Colaboraciones industriales:</strong>
                                                                    <ul>
                                                                        <li>Yandex School of Data Analysis</li>
                                                                        <li>Skolkovo Institute of Science and Technology</li>
                                                                    </ul>
                                                                </li>
                                                            </li>
                                                        </ul>
                                                    )
                                                }

                                            ].map((item, index) => (
                                                <div className="accordion-item" key={index}>
                                                    <button
                                                        className={`accordion-button ${activeIndex === index ? 'active' : ''}`}
                                                        onClick={() => toggleAccordion(index)}
                                                    >
                                                        {item.title}
                                                        <span className="accordion-icon">
                                                            {activeIndex === index ? '−' : '+'}
                                                        </span>
                                                    </button>
                                                    <div
                                                        className="accordion-body"
                                                        style={{
                                                            display: activeIndex === index ? 'block' : 'none'
                                                        }}
                                                    >
                                                        {item.content}
                                                    </div>
                                                </div>
                                            ))}
                                        </div>

                                        {/* ============ ÍTEM 4 ============ */}
                                        <h2>4. Costo de Vida Accesible</h2>

                                        <p>
                                            Costo de vida competitivo. Desde $400/mes en ciudades como Kazán vs $1,200+ en Europa Occidental (datos Numbeo 2024).
                                        </p>

                                        <div className="row">
                                            <div className="col-md-6">
                                                <h5>Comparativa Mensual (USD)</h5>
                                                <ul className="list-group">
                                                    <li className="list-group-item d-flex justify-content-between align-items-center">
                                                        Alojamiento
                                                        <span className="badge bg-primary rounded-pill">$150-$300</span>
                                                    </li>
                                                    <li className="list-group-item d-flex justify-content-between align-items-center">
                                                        Comida
                                                        <span className="badge bg-primary rounded-pill">$200</span>
                                                    </li>
                                                </ul>
                                            </div>
                                            <div className="col-md-6">
                                                <img src="/assets/img/gallery/rusas-universidad-clases.png" alt="Comparativa costo de vida Rusia vs Europa" className="img-fluid" />
                                            </div>
                                        </div>
                                        <p><small>Fuente: <a href="https://www.numbeo.com" target="_blank" rel="noopener">Numbeo 2024</a></small></p>




                                        {/* ============ ÍTEM 5 ============ */}
                                        <h2>5. Visa de Trabajo para Graduados </h2>
                                        <p>
                                            Los egresados pueden solicitar residencia laboral mediante el programa "Highly Qualified Specialist".
                                        </p>

                                        <p>El programa <strong>"Highly Qualified Specialist"</strong> permite:</p>
                                        <ul>
                                            <li>Trabajar sin cuotas de inmigración</li>
                                            <li>Salario mínimo garantizado: $1,700/mes</li>
                                            <li>Residencia permanente después de 3 años</li>
                                        </ul>

                                        <ul>
                                            <li>• Visa de estudiante permite trabajar 20h/semana</li>
                                            <li>• Viajes con descuentos en transporte público</li>
                                        </ul>



                                        <div className="quote-wrapper">
                                            <div className="quotes">
                                                <h3>Datos Clave</h3>
                                                <p>
                                                    • Rusia invierte el 4.3% de su PIB en educación superior (vs 2.9% promedio OCDE), según <a href="https://data.oecd.org" target="_blank" rel="noopener noreferrer">OECD.Stat</a>.
                                                </p>
                                                <p>
                                                    • Rusia ocupa el 8° lugar mundial en producción científica según Scimago 2023, superando a Canadá y Australia.
                                                </p>
                                            </div>
                                        </div>


                                        {/* ============ ÍTEM 6 ============ */}
                                        <h2>6. Puerta a Mercados Globales</h2>

                                        <p>
                                            Acuerdos de reconocimiento de títulos con 64 países de la CIS, UE y Asia.
                                        </p>
                                        <p>
                                            Graduados de universidades rusas tienen acceso preferencial a:
                                        </p>
                                        <ul>
                                            <li>• Programa "Highly Qualified Specialist" para trabajar en Rusia</li>
                                            <li>• Acuerdos de reconocimiento diplomas con 64 países</li>
                                        </ul>

                                        <p>Ventajas laborales:</p>
                                        <div className="row">
                                            <div className="col-md-6">
                                                <div className="card">
                                                    <div className="card-body">
                                                        <h5>Reconocimiento de Títulos</h5>
                                                        <p>Válidos en 64 países incluyendo:</p>
                                                        <ul>
                                                            <li>Unión Europea</li>
                                                            <li>China</li>
                                                            <li>India</li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="card">
                                                    <div className="card-body">
                                                        <h5>Empresas Globales</h5>
                                                        <p>Convenios con:</p>
                                                        <ul>
                                                            <li>Gazprom</li>
                                                            <li>Yandex</li>
                                                            <li>Rosatom</li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>


                                        {/* ============ ÍTEM 7 ============ */}
                                        <h2>7. Clima Académico Internacional. Comunidad Internacional Activa</h2>

                                        <p>En 2024, Rusia alberga <strong>300,000+ estudiantes extranjeros</strong> de:</p>
                                        <div className="country-chips">
                                            <span className="badge bg-light text-dark">China (23%)</span>
                                            <span className="badge bg-light text-dark">India (18%)</span>
                                            <span className="badge bg-light text-dark">Medio Oriente (15%)</span>
                                        </div>
                                        <p>Con comunidades organizadas por país en todas las universidades principales.</p>
                                        <p>
                                            300,000+ estudiantes extranjeros de 170 países creando red global de contactos.
                                        </p>


                                        {/* ============ ÍTEM 8 ============ */}
                                        <h2>8. Infraestructura de Vanguardia</h2>
                                        <p>
                                            Laboratorios como en el <Link to="/skolkovo">Centro de Innovación Skolkovo</Link> (el "Silicon Valley ruso") disponibles para estudiantes.
                                        </p>

                                        <div className="row">
                                            <div className="col-md-6">
                                                <img src="assets/img/gallery/rusas-universidad-clases.png" alt="Centro de Innovación Skolkovo" className="img-fluid rounded" />
                                            </div>
                                            <div className="col-md-6">
                                                <p>Instalaciones destacadas:</p>
                                                <ul>
                                                    <li>Laboratorios de nanotecnología</li>
                                                    <li>Simuladores espaciales</li>
                                                    <li>Bibliotecas con 5M+ volúmenes</li>
                                                </ul>
                                            </div>
                                        </div>



                                        {/* ============ ÍTEM 9 ============ */}
                                        <h2>9. Sistema de Salud Incluido</h2>
                                        <p>Todos los estudiantes reciben:</p>
                                        <ul>
                                            <li><strong>Seguro médico y atención gratuita:</strong> Cobertura completa</li>
                                            <li><strong>Clínicas universitarias:</strong> Atención 24/7</li>
                                            <li><strong>Vacunación:</strong> Voluntaria e incluida</li>
                                        </ul>


                                        {/* ============ ÍTEM 10 ============ */}
                                        <h2>10. Experiencia Cultural Única. Cultura e Historia Viva</h2>
                                        <p>
                                            Desde el <Link to="/metro-moscu">metro de Moscú</Link> hasta el festival "Noches Blancas" en San Petersburgo.
                                        </p>
                                        <p>
                                            Acceso gratuito a museos y descuentos en teatros incluyendo el Hermitage y el Bolshói (según <a href="https://www.culture.ru" target="_blank">portal cultural oficial</a>).
                                        </p>

                                        <div className="row">
                                            <div className="col-md-4">
                                                <div className="card">
                                                    <img src="assets/img/gallery/rusas-universidad-clases.png" className="card-img-top" alt="Museo Hermitage" />
                                                    <div className="card-body">
                                                        <h5>Acceso Gratuito</h5>
                                                        <p>500+ museos para estudiantes</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-8">
                                                <p>Beneficios culturales:</p>
                                                <ul>
                                                    <li>50% descuento en teatros como el Bolshói</li>
                                                    <li>Festivales gratuitos como "Noches Blancas"</li>
                                                </ul>
                                            </div>
                                        </div>





                                        <br></br>


                                        {/* ===== SECCIÓN FINAL ===== */}
                                        <div className="alert alert-info mt-4">
                                            <h4>¿Cómo Aplicar?</h4>
                                            <ol>
                                                <li>Elige tu programa en <a href="https://studyinrussia.ru" target="_blank" rel="noopener">studyinrussia.ru</a></li>
                                                <li>Prepara documentos (traducidos al ruso)</li>
                                                <li>Postula antes del 15/12/2025</li>
                                            </ol>
                                        </div>

                                        <br></br> <br></br>




                                        <div className="faq-section">
                                            <h3>FAQ: Preguntas Frecuentes</h3>
                                            <p><strong>¿Cuánto cuesta vivir?</strong><br />
                                                Entre $300-$600/mes incluyendo residencia universitaria (según <a href="https://www.numbeo.com" target="_blank">Numbeo</a>).</p>

                                            <p><strong>¿Necesito saber ruso?</strong><br />
                                                No para programas en inglés, pero todas las universidades ofrecen <Link to="/cursos-ruso">cursos gratuitos</Link>.</p>
                                        </div>

                                        {/* ==================== Referencias Académicas ==================== */}
                                        <div className="container mt-5 references">
                                            <h4>Fuentes Consultadas</h4>
                                            <ul>
                                                <li>• UNESCO Institute for Statistics (2023). <em>Global Education Monitoring Report</em></li>
                                                <li>• QS World University Rankings 2024</li>
                                                <li>• Russian Ministry of Science and Higher Education</li>
                                                <li>• OECD Education at Glance 2023 Report</li>

                                            </ul>
                                        </div>


                                    </article>
                                </div>
                            </div>

                            {/* ============= Sección de navegación ============= */}
                            <div className="navigation-top">
                                <div className="d-sm-flex justify-content-between text-center">
                                    <p className="like-info">
                                        <span className="align-middle">
                                            <i className="fa fa-heart" />
                                        </span>{" "}
                                        Lily and 4 people like this
                                    </p>
                                    <div className="col-sm-4 text-center my-2 my-sm-0">
                                        <p className="comment-count">
                                            <span className="align-middle">
                                                <i className="fa fa-comment" />
                                            </span> 06 Comments
                                        </p>
                                    </div>
                                    <ul className="social-icons">
                                        <li>
                                            <a href="#">
                                                <i className="fab fa-facebook-f" />
                                            </a>
                                        </li>
                                        <li>
                                            <a href="#">
                                                <i className="fab fa-twitter" />
                                            </a>
                                        </li>
                                        <li>
                                            <a href="#">
                                                <i className="fab fa-dribbble" />
                                            </a>
                                        </li>
                                        <li>
                                            <a href="#">
                                                <i className="fab fa-behance" />
                                            </a>
                                        </li>
                                    </ul>
                                </div>

                                <div className="navigation-area">
                                    <div className="row">
                                        <div className="col-lg-6 col-md-6 col-12 nav-left flex-row d-flex justify-content-start align-items-center">
                                            <div className="thumb">
                                                <a href="#">
                                                    <img
                                                        className="img-fluid"
                                                        src="/assets/img/post/preview.png"
                                                        alt="Post anterior"
                                                    />
                                                </a>
                                            </div>
                                            <div className="arrow">
                                                <a href="#">
                                                    <span className="lnr text-white ti-arrow-left" />
                                                </a>
                                            </div>
                                            <div className="detials">
                                                <p>Prev Post</p>
                                                <a href="#">
                                                    <h4>Fiestas de Salsa en Invierno</h4>
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-6 col-md-6 col-12 nav-right flex-row d-flex justify-content-end align-items-center">
                                            <div className="detials">
                                                <p>Next Post</p>
                                                <a href="#">
                                                    <h4>Mejores Academias de Baile</h4>
                                                </a>
                                            </div>
                                            <div className="arrow">
                                                <a href="#">
                                                    <span className="lnr text-white ti-arrow-right" />
                                                </a>
                                            </div>
                                            <div className="thumb">
                                                <a href="#">
                                                    <img
                                                        className="img-fluid"
                                                        src="/assets/img/post/next.png"
                                                        alt="Siguiente post"
                                                    />
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* ============= Sección del autor ============= */}
                            <div className="blog-author">
                                <div className="media align-items-center">
                                    <img src="/assets/img/gallery/rusas-universidad-clases.png" alt="Experto en educación internacional" />
                                    <div className="media-body">
                                        <a href="#"><h4>Dra. Irina Volkova</h4></a>
                                        <p>Asesora académica con 10 años en reclutamiento internacional. Ex directora de admisiones en RUDN University.</p>
                                    </div>
                                </div>
                            </div>

                            {/* ============= Sección de comentarios ============= */}
                            <div className="comments-area">
                                <h4>03 Comments</h4>
                                <div className="comment-list">
                                    <div className="single-comment justify-content-between d-flex">
                                        <div className="user justify-content-between d-flex">
                                            <div className="thumb">
                                                <img src="/assets/img/comment/comment_1.png" alt="Usuario comentario 1" />
                                            </div>
                                            <div className="desc">
                                                <p className="comment">
                                                    ¡Increíble ambiente! La mejor forma de disfrutar el verano en Moscú. Recomendado 100%
                                                </p>
                                                <div className="d-flex justify-content-between">
                                                    <div className="d-flex align-items-center">
                                                        <h5>
                                                            <a href="#">Anna Petrova</a>
                                                        </h5>
                                                        <p className="date">May 15, 2024 at 3:12 pm </p>
                                                    </div>
                                                    <div className="reply-btn">
                                                        <a href="#" className="btn-reply text-uppercase">
                                                            reply
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="comment-list">
                                    <div className="single-comment justify-content-between d-flex">
                                        <div className="user justify-content-between d-flex">
                                            <div className="thumb">
                                                <img src="/assets/img/comment/comment_2.png" alt="Usuario comentario 2" />
                                            </div>
                                            <div className="desc">
                                                <p className="comment">
                                                    ¿Hay estacionamiento cerca del Parque Gorky? Quisiera asistir en auto
                                                </p>
                                                <div className="d-flex justify-content-between">
                                                    <div className="d-flex align-items-center">
                                                        <h5>
                                                            <a href="#">Dmitry Sokolov</a>
                                                        </h5>
                                                        <p className="date">May 16, 2024 at 10:30 am </p>
                                                    </div>
                                                    <div className="reply-btn">
                                                        <a href="#" className="btn-reply text-uppercase">
                                                            reply
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* Formulario de comentarios */}
                                <div className="comment-form">
                                    <h4>Deja un comentario</h4>
                                    <form className="form-contact comment_form" action="#" id="commentForm">
                                        <div className="row">
                                            <div className="col-12">
                                                <div className="form-group">
                                                    <textarea
                                                        className="form-control w-100"
                                                        name="comment"
                                                        id="comment"
                                                        cols={30}
                                                        rows={9}
                                                        placeholder="Escribe tu comentario"
                                                        defaultValue={""}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-sm-6">
                                                <div className="form-group">
                                                    <input
                                                        className="form-control"
                                                        name="name"
                                                        id="name"
                                                        type="text"
                                                        placeholder="Nombre"
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-sm-6">
                                                <div className="form-group">
                                                    <input
                                                        className="form-control"
                                                        name="email"
                                                        id="email"
                                                        type="email"
                                                        placeholder="Email"
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-12">
                                                <div className="form-group">
                                                    <input
                                                        className="form-control"
                                                        name="website"
                                                        id="website"
                                                        type="text"
                                                        placeholder="Sitio web"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <button
                                                type="submit"
                                                className="button button-contactForm btn_1 boxed-btn"
                                            >
                                                Publicar comentario
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>

                        {/* ==================== Sidebar ==================== */}

                        {/* ==================== Sidebar Completo ==================== */}
                        <div className="col-lg-4">
                            <div className="blog_right_sidebar">
                                <aside className="single_sidebar_widget search_widget">
                                    <form action="#">
                                        <div className="form-group">
                                            <div className="input-group mb-3">
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Buscar"
                                                    onFocus={(e) => e.target.placeholder = ''}
                                                    onBlur={(e) => e.target.placeholder = 'Buscar'}
                                                />
                                                <div className="input-group-append">
                                                    <button className="btns" type="button">
                                                        <i className="ti-search" />
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                        <button
                                            className="button rounded-0 primary-bg text-white w-100 btn_1 boxed-btn"
                                            type="submit"
                                        >
                                            Buscar
                                        </button>
                                    </form>
                                </aside>

                                <aside className="single_sidebar_widget post_category_widget">
                                    <h4 className="widget_title">Categorías</h4>
                                    <ul className="list cat-list">
                                        <li>
                                            <a href="#" className="d-flex">
                                                <p>Eventos</p>
                                                <p>(25)</p>
                                            </a>
                                        </li>
                                        <li>
                                            <a href="#" className="d-flex">
                                                <p>Clases</p>
                                                <p>(12)</p>
                                            </a>
                                        </li>
                                        <li>
                                            <a href="#" className="d-flex">
                                                <p>Consejos</p>
                                                <p>(8)</p>
                                            </a>
                                        </li>
                                        <li>
                                            <a href="#" className="d-flex">
                                                <p>Vida Estudiantil</p>
                                                <p>(15)</p>
                                            </a>
                                        </li>
                                        <li>
                                            <a href="#" className="d-flex">
                                                <p>Becas</p>
                                                <p>(25)</p>
                                            </a>
                                        </li>
                                    </ul>
                                </aside>

                                {/* ============================== */}

                                <aside className="single_sidebar_widget popular_post_widget">
                                    <h3 className="widget_title">Artículos Recientes</h3>
                                    <div className="media post_item">
                                        <img src="/assets/img/post/post_1.png" alt="Post reciente 1" />
                                        <div className="media-body">
                                            <a href="#">
                                                <h3>Domina el Ruso en 6 Meses</h3>
                                            </a>
                                            <p>Mayo 10, 2024</p>
                                        </div>
                                    </div>
                                    <div className="media post_item">
                                        <img src="/assets/img/post/post_2.png" alt="Post reciente 2" />
                                        <div className="media-body">
                                            <a href="#">
                                                <h3>Historia del Baile en Rusia</h3>
                                            </a>
                                            <p>Abril 28, 2024</p>
                                        </div>
                                    </div>
                                    <div className="media post_item">
                                        <img src="/assets/img/post/post_3.png" alt="post" />
                                        <div className="media-body">
                                            <a href="#">
                                                <h3>Astronomy Or Astrology</h3>
                                            </a>
                                            <p>03 Days ago</p>
                                        </div>
                                    </div>
                                    <div className="media post_item">
                                        <img src="/assets/img/post/post_4.png" alt="post" />
                                        <div className="media-body">
                                            <a href="#">
                                                <h3>Asteroids telescope</h3>
                                            </a>
                                            <p>01 Days ago</p>
                                        </div>
                                    </div>
                                </aside>

                                {/* ============================== */}

                                <aside className="single_sidebar_widget tag_cloud_widget">
                                    <h4 className="widget_title">Etiquetas</h4>
                                    <ul className="list">
                                        <li><a href="#">Universidades</a></li>
                                        <li><a href="#">Estudiar medicina</a></li>
                                        <li><a href="#">Moscú</a></li>
                                        <li><a href="#">Idioma Ruso</a></li>
                                        <li><a href="#">Costo de vida</a></li>
                                        <li><a href="#">Carreras</a></li>
                                    </ul>
                                </aside>

                                {/* ============================== */}

                                <aside className="single_sidebar_widget instagram_feeds">
                                    <h4 className="widget_title">Instagram</h4>
                                    <ul className="instagram_row flex-wrap">
                                        <li><a href="#"><img className="img-fluid" src="/assets/img/post/post_5.png" alt="" /></a></li>
                                        <li><a href="#"><img className="img-fluid" src="/assets/img/post/post_6.png" alt="" /></a></li>
                                        <li><a href="#"><img className="img-fluid" src="/assets/img/post/post_7.png" alt="" /></a></li>
                                        <li><a href="#"><img className="img-fluid" src="/assets/img/post/post_8.png" alt="" /></a></li>
                                        <li><a href="#"><img className="img-fluid" src="/assets/img/post/post_9.png" alt="" /></a></li>
                                        <li><a href="#"><img className="img-fluid" src="/assets/img/post/post_10.png" alt="" /></a></li>
                                    </ul>
                                </aside>

                                <aside className="single_sidebar_widget newsletter_widget">
                                    <h4 className="widget_title">Newsletter</h4>
                                    <form action="#">
                                        <div className="form-group">
                                            <input
                                                type="email"
                                                className="form-control"
                                                placeholder="Ingresa tu email"
                                                required
                                            />
                                        </div>
                                        <button
                                            className="button rounded-0 primary-bg text-white w-100 btn_1 boxed-btn"
                                            type="submit"
                                        >
                                            Suscribirse
                                        </button>
                                    </form>
                                </aside>
                            </div>
                        </div>


                    </div>
                </div>
            </section>









            <Footer />
        </main >
    );
}

export default StudyInRussia;